﻿function getButton(e) {
    return $(e.target).siblings('[data-trigger-button]');
}

function show(e) {
    getButton(e).text('View less');
    //getButton(e).hide();
    $('[data-view-all]').removeClass('hidden');
}


function hide(e) {
    getButton(e).text('View more');
    $('[data-view-all]').addClass('hidden');
}

export function setupFleetManagement() {
    if ($('[data-fleet-management]').length) {
        const moreTaggedNews = $('#more-tagged-news');
        moreTaggedNews.on('show.bs.collapse', show);
        moreTaggedNews.on('hide.bs.collapse', hide);
    }

}
